import { Theme, css } from '@emotion/react';

export const purchaseCancellationPolicyDescriptionRootStyles = ({ colors }: Theme) => css`
  border: 1px solid ${colors.borderDefault};
`;

export const purchaseCancellationPolicyDescriptionStyles = ({ spacing }: Theme) => css`
  margin-bottom: ${spacing(1)}px;
  &:last-child {
    margin-bottom: 0;
  }
`;
